<template>
  <div class="top-bar">
    <router-link
      class="bar-item"
      v-for="item in topbarList"
      :key="item.name"
      :class="{
        active: item.isActive,
        disabled: item.isDisabled,
      }"
      :to="item.isDisabled ? '' : item.path"
      >{{ item.name }}</router-link
    >
  </div>
</template>

<script>
export default {
  props: {
    topbarList: {
      type: Array,
    },
  },
};
</script>

<style lang="less" scoped>
.top-bar {
  position: relative;
  height: 40px;
  line-height: 40px;
  font-size: 0;
  overflow-y: hidden;
  white-space: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: block;
  }
  &::before {
    position: absolute;
    content: "";
    height: 1px;
    bottom: 0;
    left: 0;
    right: 0;
    background: #eeeeee;
  }
  .bar-item {
    position: relative;
    display: inline-block;
    height: 40px;
    line-height: 48px;
    margin: 0 15px;
    min-width: 0;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #666;
    text-align: center;
    box-sizing: border-box;
    text-decoration: none;
    cursor: pointer;
    &.active::after {
      position: absolute;
      height: 2px;
      background: #38f;
      content: "";
      bottom: 0;
      width: 100%;
      left: 0;
    }
    &.disabled {
      cursor: no-drop;
    }
  }
}
</style>
